import { useRouter } from "next/router";

import pageFromQuery from "utils/pageFromQuery";

import ItemCount from "components/ItemCount/ItemCount";
import PageNavigation from "components/PageNavigationV2";
import ShopItemCard from "components/ShopItemCard";
import { ShopItem } from "components/ShopItemCard/types";
import Sort from "components/UnifiedShop/Sort";
import { UNIFIED_SHOP_PAGE_SIZE } from "components/UnifiedShop/UnifiedShop";

type ShopItemResultsProps = {
  shopItems: ShopItem[];
  totalCount: number;
};

const BACKEND_PAGINATION_LIMIT = 10000;

const ShopItemResults: React.FC<ShopItemResultsProps> = ({
  shopItems,
  totalCount,
}) => {
  const {
    query: { page },
  } = useRouter();
  const currentPage = pageFromQuery(page);

  return (
    <div>
      <div className="flex justify-between">
        <ItemCount itemCount={totalCount} />
        {!!shopItems?.length && <Sort />}
      </div>
      <hr className="border-light-grey md:hidden mb-md mt-sm -mx-lg" />
      {shopItems.length &&
        shopItems.map((shopItem, idx) => {
          return <ShopItemCard key={idx} shopItem={shopItem} />;
        })}
      <PageNavigation
        className="my-8"
        currentPage={currentPage}
        totalPages={
          totalCount > BACKEND_PAGINATION_LIMIT
            ? Math.ceil(BACKEND_PAGINATION_LIMIT / UNIFIED_SHOP_PAGE_SIZE) - 1
            : Math.ceil(totalCount / UNIFIED_SHOP_PAGE_SIZE)
        }
      />
    </div>
  );
};

export default ShopItemResults;
